import { CartAddition, CartAdditionOption } from './cart';
import { rightPrice } from '../src/hooks/useTotalPrice';

export const sumCartAddition = ({ quantity, item, options, vatType }: CartAddition) =>
  quantity *
  (rightPrice(vatType, item.price, item.takeawayPrice) +
    options.reduce((acc, curr) => acc + sumCartAdditionOption(curr), 0));

export const sumCartAdditionOption = ({ quantity, option, vatType }: CartAdditionOption) =>
  quantity * rightPrice(vatType, option.price, option.takeawayPrice);
